import styled from '@emotion/styled';
import { FlipX } from '@hotjar/webapp/utils/animations';
import SPINNER_ICON from '@hotjar/shared-assets/images/icons/icon-status-running.gif';

export const RunningStateIcon = styled.span`
  display: block;
  width: 25px;
  height: 25px;
  flex-shrink: 0;
  border-radius: 1.2em;
  box-sizing: border-box;
  background-size: contain;
  background-repeat: no-repeat;
  backface-visibility: visible;
  background-image: url('${SPINNER_ICON}');
  animation: ${FlipX} 0.5s ease;
`;
